import { render, staticRenderFns } from "./dashboardCheck.vue?vue&type=template&id=5752fdb8&scoped=true"
import script from "./dashboardCheck.vue?vue&type=script&lang=js"
export * from "./dashboardCheck.vue?vue&type=script&lang=js"
import style0 from "./dashboardCheck.vue?vue&type=style&index=0&id=5752fdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752fdb8",
  null
  
)

export default component.exports